export default __webpack_public_path__ + "static/media/black@3x.6fae401b.png";